export enum PedigreeVisibility {
  NotVisible = 0,
  VisibleWithLink = 1,
  VisibleNoLink = 2
}
